import { useFlexibleAssociations } from '../../hooks/useFlexibleAssociations';
import { useStrategy } from '../../hooks/useStrategy';
import ViewerAssociatedCrmObjectHeadingText from './ViewerAssociatedCrmObjectHeadingText';
import ViewerUnifiedEventHeadingText from './ViewerUnifiedEventHeadingText';
import { useUnifiedEventCompletionStatus } from '../../hooks/useUnifiedEventCompletionStatus';
import { ENGAGEMENT_PROPERTY } from '../../filterQueryFormat/DSAssetFamilies/DSAssetFamilies';
import { hasActivityFilters, hasActivityObjectDisabled } from '../../permissions/gates';
import ActivityFilterInfoTooltip from '../common/ActivityFilterInfoTooltip';
import { IconHolder } from 'foundations-components/transitional/components/IconHolder';
import { InfoIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ViewerRelatedConditionsHeadingText = props => {
  const {
    logicGroup,
    conditionPath
  } = props;
  const {
    getFilterFamilyGroupHeading
  } = useStrategy();
  // @ts-expect-error ts-migrate(2554) FIXME: Expected 2 arguments, but got 1.
  const {
    isAssnBranch
  } = useFlexibleAssociations(logicGroup);
  const {
    showUnifiedEventCompletionStatus
  } = useUnifiedEventCompletionStatus(logicGroup, conditionPath);
  if (isAssnBranch) {
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(ViewerAssociatedCrmObjectHeadingText, {
        logicGroup: logicGroup
      }), hasActivityFilters() && hasActivityObjectDisabled() && logicGroup.filterFamily === ENGAGEMENT_PROPERTY && /*#__PURE__*/_jsx(ActivityFilterInfoTooltip, {
        listActivityObjects: true,
        children: /*#__PURE__*/_jsx(IconHolder, {
          color: "icon-core-subtle",
          marginInlineStart: "100",
          icon: InfoIcon
        })
      })]
    });
  }
  if (showUnifiedEventCompletionStatus) {
    return /*#__PURE__*/_jsx(ViewerUnifiedEventHeadingText, {
      logicGroup: logicGroup
    });
  }
  const filterFamilyHeading = getFilterFamilyGroupHeading(logicGroup.filterFamily, logicGroup.associationTypeId, false);
  return filterFamilyHeading || null;
};
export default ViewerRelatedConditionsHeadingText;